import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { useAuthStore } from "../../../store/auth.store";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function ResetPasswordChange() {
    const navigate = useNavigate();
    const {
        isAcceptedRegistration,
        sendPassword,
    } = useAuthStore();
    if (!isAcceptedRegistration) navigate("/");

    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [error, setError] = useState("");
    const [errorRepeat, setErrorRepeat] = useState("");

    const handleChangePassword = (event: any) => {
        setPassword(event.target.value);
    };

    const handleChangePasswordRepeat = (event: any) => {
        if (event.target.value != password)
            setErrorRepeat("Пароли не совпадают");
        else setErrorRepeat("");
        setPasswordRepeat(event.target.value);
    };

    const handleSendPassword = () => {
        if (password != passwordRepeat) return setErrorRepeat("Пароли не совпадают");
        else setErrorRepeat("");
        sendPassword(password);
    };

    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Paper
                sx={{
                    padding: "40px",
                    margin: "0 40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "left",
                    gap: "8px",
                }}
            >
                <h1>Восстановление пароля</h1>
                <Typography>Введите новый пароль для вашего аккаунта</Typography>
                <TextField
                    error={error != ""}
                    helperText={error}
                    value={password}
                    onChange={handleChangePassword}
                    placeholder="Пароль"
                    type="password"
                />
                <TextField
                    error={errorRepeat != ""}
                    helperText={errorRepeat}
                    value={passwordRepeat}
                    onChange={handleChangePasswordRepeat}
                    placeholder="Повтор пароля"
                    type="password"
                />
                <Button variant="contained" onClick={handleSendPassword}>
                    Сменить пароль
                </Button>
            </Paper>
        </Box>
    );
}
